import { RegimePatrimoniale, SectionVM } from 'civil-status/view-models/step-form';

export const transformerRegimePatrimoniale = (
  dataSection?: SectionVM
): RegimePatrimoniale | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idRegimePatrimoniale: dataSection.idRegimePatrimoniale || null,
    },
    tipoRegimePatrimoniale: dataSection?.propertyRegime || undefined,
    numeroLegge: dataSection.lawPropertyRegime || undefined,
    flagConAttoNotarile: dataSection.isWithNotarialDeed ? '1' : '0',
    descrizioneCognomeNotaio: dataSection.surnameNotary || undefined,
    descrizioneNomeNotaio: dataSection.nameNotary || undefined,
    nomeDistrettoNotarile: dataSection.notarialDistrict || undefined,
    dataAttoNotarile: dataSection.datePropertyRegime
      ? dataSection.datePropertyRegime.toFormat('yyyy-MM-dd')
      : undefined,
    numeroRepertorio: dataSection.repertoireNumber || undefined,
    numeroRaccolta: dataSection.collectionNumber || undefined,
    tipoSezione: dataSection.typePersistence || undefined,
  };
};
